/**
 * Accessibility patch for the Judge.me review widget's trust medals.
 *
 * Judge.me renders each medal as a link wrapping an <svg> whose only description
 * lives in a `title` *attribute*. An SVG `title` attribute is not a `<title>`
 * element: it contributes nothing to the accessible name, so the link has no
 * name at all (2.4.4 Link Purpose), and it renders as an undismissable native
 * tooltip (1.4.13 Content on Hover). Moving that text onto the link as its
 * accessible name and dropping the attribute fixes both at once.
 *
 * The widget is a Vue app that mounts after page load, sets `title` as an
 * attribute binding, and re-renders on pagination — so this watches for
 * childList *and* title-attribute changes rather than running once. Passes are
 * coalesced with requestAnimationFrame so a burst of widget mutations costs one
 * check, and patching is idempotent: once `title` is gone a medal is skipped.
 */
(function () {
  var MEDAL_LINK = '.jm-medals__medal-link';
  var scheduled = false;

  function patchMedals() {
    var links = document.querySelectorAll(MEDAL_LINK);

    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var svg = link.querySelector('svg[title]');
      if (!svg) continue; // already patched, or Vue has not set the title yet

      var title = (svg.getAttribute('title') || '').trim();
      if (title && !(link.getAttribute('aria-label') || '').trim()) {
        link.setAttribute('aria-label', title);
      }

      // Drop the tooltip-producing attribute and take the now-redundant graphic
      // out of the accessibility tree; the link carries the name.
      svg.removeAttribute('title');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      patchMedals();
    });
  }

  function init() {
    patchMedals();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['title'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
